import { gql } from 'urql';

export const SET_MYELF_ACTIVE = gql`
  mutation SetMyselfActive {
    setMyselfActive {
      email
    }
  }
`;
